import { Link, useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { ShopbyFestivalComponentGrid } from '../../@types/aboutfishing'
import { RNPostMessage, AFWebLinkType } from '../../js/postMessage'
import { useAppContext } from '../provider/AppProvider'

interface FestivalGridItemProps {
  item: ShopbyFestivalComponentGrid
}

const FestivalGridItem = ({ item }: FestivalGridItemProps) => {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const sectionTypeHandler = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/festivalsection?sectionNo=${item.no}`,
      })
    } else {
      navigate(`/festivalsection`, {
        state: {
          path: '',
          sectionNo: item.no,
        },
      })
    }
  }

  const categoryExhibitionTypeHandler = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, {
        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}${item.path}`,
      })
    } else {
      navigate(item.path, {
        state: {
          path: item.path,
          sectionNo: item.no,
        },
      })
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    // 기획전=exhibition, 카테고리=category, 상품진열=section, url
    if (['url', 'section'].includes(item.type)) sectionTypeHandler()
    else categoryExhibitionTypeHandler()
  }

  return (
    <div>
      <Link to={item.path} onClick={handleClick}>
        <img src={isMobile ? item.mobileImageUrl : item.pcImageUrl} alt='' style={{ width: '100%' }} />
      </Link>
    </div>
  )
}

export default FestivalGridItem
